module.exports = __webpack_public_path__ + "img/SDMO-landing-NB.02f30b79.jpg";